import gql from "graphql-tag";


// List all active jobs, used in the dashboard as we need to list all the
// active jobs, without pagination nor filters.
export const LIST_ACTIVE_JOBS = gql`
  query all_active_jobs($warehouseId:String!) {
    all_active_jobs(warehouseId: $warehouseId) {
      jobId
      orderId
      orgOrderId
      warehouseId
      cancelled
      state
      prepDate
      pickupDate
      recipientName
      recipient {
        name
        attName
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
      }
      packages {
        packageId
        batchId
        skus {
          sku
          quantity
          serial
          serialNrs
        }
        state
        trackingNr
      }
    }
  }
`;

// List started jobs, with filter, pagination and sorting. Used in the jobs
// listing page for each warehouse.
export const LIST_STARTED_JOBS = gql`
  query started_jobs($warehouseId:String!, $filter:JobFilterInput, $pagination:PaginationInput, $sortOrders:[SortingInput]) {
    started_jobs(warehouseId: $warehouseId, filter:$filter, pagination: $pagination, sortOrders: $sortOrders) {
      entries {
        jobId
        orderId
        orgOrderId
        warehouseId
        cancelled
        state
        prepDate
        pickupDate
        recipientName
        recipient {
          name
          attName
          addressAddressLine1
          addressAddressLine2
          addressCity
          addressPostcode
          addressStateProvince
          addressCountryName
        }
        packages {
          packageId
          batchId
          skus {
            sku
            quantity
            serial
            serialNrs
          }
          state
          trackingNr
        }
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`;

// SUBSCRIPTIONS
export const ON_NEW_JOB = gql`
  subscription newJob($warehouseId: ID!) {
    newJob(warehouseId: $warehouseId) {
      jobId
      orderId
      orgOrderId
      warehouseId
      cancelled
      state
      prepDate
      pickupDate
      recipientName
      recipient {
        name
        attName
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
      }
      packages {
        packageId
        batchId
        skus {
          sku
          quantity
          serial
          serialNrs
        }
        state
        trackingNr
      }
    }
  }
`;
export const ON_UPDATED_JOB = gql`
  subscription updatedJob($warehouseId: ID!) {
    updatedJob(warehouseId: $warehouseId) {
      jobId
      orderId
      orgOrderId
      warehouseId
      cancelled
      state
      prepDate
      pickupDate
      recipientName
      recipient {
        name
        attName
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryName
      }
      packages {
        packageId
        batchId
        skus {
          sku
          quantity
          serial
          serialNrs
        }
        state
        trackingNr
      }
    }
  }
`;


// IDLE TO PICKING
export const START_BATCH_PICKING = gql`
  mutation startBatchPicking($data: JobInfoForBatchInput!) {
    startBatchPicking(input: $data) {
      errors { key message }
    }
  }
`;
export const CANCEL_BATCH_PICKING = gql`
  mutation cancelBatchPicking($data: JobInfoForBatchInput!) {
    cancelBatchPicking(input: $data) {
      errors { key message }
    }
  }
`;

// PICKING TO PACKING
export const MARK_BATCH_PICKED = gql`
  mutation markBatchPicked($data: JobInfoForBatchInput!) {
    markBatchPicked(input: $data) {
      errors { key message }
    }
  }
`;
export const CANCEL_PACKING = gql`
  mutation cancelPacking($data: JobInfoForPackagesInput!) {
    cancelPacking(input: $data) {
      errors { key message }
    }
  }
`;

// PACKING TO PICKUP_READY
export const DOWNLOAD_LABELS = gql`
  query downloadLabels($data: JobInfoForPackagesInput!) {
    downloadLabels(input: $data) {
      path
    }
  }
`;

export const ASSIGN_SERIAL_NRS = gql`
  mutation assignSerialNrs($data: AssignSerialToPackageInput!) {
    assignSerialNrs(input: $data) {
      errors { key message }
    }
  }
`;

export const MARK_PACKED = gql`
  mutation markPacked($data: JobInfoForPackagesInput!) {
    markPacked(input: $data) {
      errors { key message }
    }
  }
`;
export const CANCEL_PACKED = gql`
  mutation cancelPacked($data: JobInfoForPackagesInput!) {
    cancelPacked(input: $data) {
      errors { key message }
    }
  }
`;


// PICKUP_READY TO IN_TRANSIT
export const MARK_LOADED = gql`
  mutation markLoaded($data: JobInfoForLoading!) {
    markLoaded(input: $data) {
      errors { key message }
    }
  }
`;
export const CANCEL_LOADED = gql`
  mutation cancelLoaded($data: JobInfoForPackagesInput!) {
    cancelLoaded(input: $data) {
      errors { key message }
    }
  }
`;


// Cancellation acknowledgment (from any lane)
export const CONFIRM_CANCELLATION = gql`
  mutation confirmJobCancellation($data: JobInfoInput!) {
    confirmJobCancellation(input: $data) {
      errors { key message }
    }
  }
`;
